import styled from 'styled-components';

export const RelatedWrapper = styled.div`
  height: inherit;
  display: block;
`;
